// extracted by mini-css-extract-plugin
export default {"container":"EBook__container--BgBEfYoLcj"};